import type { ReactNode } from 'react'
import { FlowFrame } from '@/routes/_app/-components/shared/flow-frame'
import { HomeLink } from '@/routes/_app/-components/shared/home-link'
import { AuthLayout } from '@/routes/_app/-components/auth/auth-layout'

export function AuthCard(props: {
  title?: ReactNode
  subtitle?: ReactNode
  /** Custom header node, replacing the default centered title/subtitle block (e.g. to show an avatar). */
  header?: ReactNode
  /** Inline content for the muted footer line below the card (rendered inside a `<p>`; pass text + links). */
  footer?: ReactNode
  /** Classes for the flow-content wrapper, e.g. `flex flex-col gap-5` to stack form sections. */
  contentClassName?: string
  /** Show the brand logo above the card linking back to the landing page (initial login/register entry). */
  home?: boolean
  children: ReactNode
}) {
  const card = (
    <div className="mx-auto flex w-full max-w-120 flex-col items-center gap-6 p-6">
      {props.home && <HomeLink />}
      {props.header ??
        ((props.title || props.subtitle) && (
          <div className="flow-header text-center">
            {props.title && (
              <h1 className="text-3xl leading-tight font-semibold tracking-tight text-balance sm:text-4xl">
                {props.title}
              </h1>
            )}
            {props.subtitle && <p className="text-muted-foreground mt-2 text-pretty">{props.subtitle}</p>}
          </div>
        ))}
      <FlowFrame contentClassName={props.contentClassName}>{props.children}</FlowFrame>
      {props.footer && <p className="text-muted-foreground text-sm">{props.footer}</p>}
    </div>
  )

  return props.home ? <AuthLayout>{card}</AuthLayout> : card
}
